import React from 'react'
import { JsonLd, JsonLdProps } from './JsonLd'
import { VideoObject } from './types'

interface VideoObjectJsonLdProps extends JsonLdProps, VideoObject {}

export const VideoObjectJsonLd: React.FC<VideoObjectJsonLdProps> = ({ type = 'VideoObject', keyOverride, ...rest }) => (
  <JsonLd type={type} keyOverride={keyOverride} {...rest} scriptKey="VideoObject" />
)
